import { getDatabase, ref, update } from 'firebase/database';

export const toggleSessionPausedInFirebase = (sessionId: string, isPaused: boolean) => {
    const database = getDatabase();
    const sessionRef = ref(database, `session_v2/${sessionId}`);
    update(sessionRef, { pause: isPaused });
};
